"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupTypeFromChatLog = void 0;
const models_1 = require("../models");
const getGroupTypeFromChatLog = (chatLog) => {
    if (chatLog.status === models_1.CHAT_STATUS.HIDDEN) {
        return models_1.GROUP_TYPE.HIDDEN;
    }
    switch (chatLog.chatType) {
        case models_1.CHAT_TYPE.PRIVATE:
            return models_1.GROUP_TYPE.PRIVATE;
        case models_1.CHAT_TYPE.BROADCAST:
            return models_1.GROUP_TYPE.BROADCAST;
        case models_1.CHAT_TYPE.GROUP:
            return chatLog.groupType;
        default:
            throw new Error(`Unable to determine the group type from chat type: ${chatLog.chatType} and chat status: ${chatLog.status}`);
    }
};
exports.getGroupTypeFromChatLog = getGroupTypeFromChatLog;
